/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SessionBookingDto = {
    /**
     * Booking UUID
     */
    bookingId: string;
    /**
     * Booking type
     */
    bookingType: string;
    /**
     * Session type
     */
    sessionType?: string | null;
    /**
     * Total amount
     */
    totalAmount?: number | null;
    /**
     * Currency code
     */
    currency: string;
    /**
     * Payment status
     */
    paymentStatus?: string | null;
    /**
     * Package name
     */
    packageName?: string | null;
    /**
     * Booking status
     */
    status?: SessionBookingDto.status | null;
    /**
     * Total sessions
     */
    totalSessions: number;
    /**
     * Completed sessions
     */
    completedSessions: number;
    /**
     * Session progress
     */
    sessionProgress: string;
    /**
     * Package validity start date
     */
    packageValidityStart?: string | null;
    /**
     * Package validity end date
     */
    packageValidityEnd?: string | null;
    /**
     * Refund amount
     */
    refundAmount?: number | null;
    /**
     * Refund status
     */
    refundStatus?: SessionBookingDto.refundStatus | null;
};
export namespace SessionBookingDto {
    /**
     * Booking status
     */
    export enum status {
        PENDING = 'pending',
        ACTIVE = 'active',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        PAYMENT_FAILED = 'payment_failed',
        PAYMENT_FAILED_RETRYABLE = 'payment_failed_retryable',
    }
    /**
     * Refund status
     */
    export enum refundStatus {
        PENDING = 'pending',
        APPROVED = 'approved',
        DECLINED = 'declined',
        PROCESSED = 'processed',
        FAILED = 'failed',
    }
}

